import { onUnmounted, ref } from 'vue'

export const useDialog = () => {
  const isOpen = ref(false)

  const openDialog = () => {
    isOpen.value = true
  }

  const closeDialog = () => {
    isOpen.value = false
  }

  const onCloseDialog = (callback: () => void) => {
    closeDialog()
    callback()
  }

  onUnmounted(() => {
    isOpen.value = false
  })

  return { isOpen, openDialog, closeDialog, onCloseDialog }
}
